<template>
  
  <div class="ibox">
    <div class="ibox-title">
      <h2>Check Pictures</h2>
    </div>
    <div :class="'ibox-content p-md'+ (panelLoading ? ' sk-loading' : '')">

      <div v-if="panelLoading" class="sk-spinner sk-spinner-double-bounce">
          <div class="sk-double-bounce1"></div>
          <div class="sk-double-bounce2"></div>
      </div>

      <form role="form" @submit="onCheckMissingInStorageFormSubmit" name="checkMissingInStorageForm">
        <div class="form-group row">
          <div class="col">
            <v-select :options="listDBs" :getOptionLabel="listDBsOptionLabel" v-model="form.targetDB" placeholder="Select an origin DB" @keypress.enter.native.prevent="">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!form.targetDB"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
          <div class="col">
            <button class="btn btn-primary ladda-button check" data-style="zoom-in" type="submit">Check missing files in pictures</button>
            <button class="btn btn-primary ladda-button remove" data-style="zoom-in" type="submit">Remove missing files in pictures</button>
          </div>
        </div>
      </form>

    </div>
  </div>
        
</template>

<style scoped>
  
</style>



<script lang="ts">
import Vue from '@fwk-node-modules/vue';
import { Component, Watch } from '@fwk-node-modules/vue-property-decorator';
import * as api from '@fwk-client/utils/api';
import * as Ladda from 'ladda';

@Component({
  components: {}
})
export default class CheckPictures extends Vue {


  form:any = {
    targetDB:"",
  }

  listDBs:any[] = [];

  panelLoading:boolean = false;

  laddaCheckMissingInStorageSubmit:Ladda.LaddaButton|null = null;
  laddaRemoveMissingInStorageSubmit:Ladda.LaddaButton|null = null;

  mounted() {
    var missingCheckButton:HTMLButtonElement|null = document.querySelector( 'form[name=checkMissingInStorageForm] button.check' );
    this.laddaCheckMissingInStorageSubmit = Ladda.create(missingCheckButton!);

    var missingRemoveButton:HTMLButtonElement|null = document.querySelector( 'form[name=checkMissingInStorageForm] button.remove' );
    this.laddaRemoveMissingInStorageSubmit = Ladda.create(missingRemoveButton!);
  }

  created() {
    this.updateListDBs();
  }

  updateListDBs() {
    // We need to get the list of available companies for the current logged in user
    var options:api.ApiVueOptions =  {
      app: this
    }
    this.panelLoading = true;
    api.getAPI('/api/admin/database/configs', options).then((response:any) => {
      if(response.configs) {  
        this.listDBs = response.configs;
      }
      else {
        this.listDBs = [];
      }
      this.panelLoading = false;
    });
  }

  listDBsOptionLabel(option:any) {
    return option.title;
  }

  onCheckMissingInStorageFormSubmit(evt:SubmitEvent) {
    evt.preventDefault();

    var path = '/api/admin/storage/statics/check-missing-files-pictures';
    var laddaButton = this.laddaCheckMissingInStorageSubmit!;
    if(evt.submitter && evt.submitter.classList.contains("remove")) {
      path = '/api/admin/storage/statics/remove-missing-files-pictures';
      laddaButton = this.laddaRemoveMissingInStorageSubmit!;
    }

    var options:api.ApiVueOptions =  {
      app: this
    }

    var input = {
      targetDB : this.form.targetDB.title
    }

    laddaButton.start();

    return api.postAPI(path, input,  options).then((response:any) => {
      laddaButton.stop();
    })
  }
  
}
</script>